<script setup>
import { watch, computed } from 'vue'
import { RouterView, useRouter } from 'vue-router'
import { storeToRefs } from 'pinia'
import { useConfigsStore } from '@/stores/configs'
import { useUserStore } from '@provise/stores/user'
import Modalstack from '@provise/components/modalstack.vue'
import MessageStack from '@provise/components/messagestack.vue'
import SignedLayout from '@provise/layouts/signed.vue'
import SsoLogin from '@provise/views/login/sso.vue'
import Login from '@provise/views/login.vue'
import Fillinfo from '@provise/views/login/fillinfo.vue'
import BlockScreen from '@provise/components/blockscreen.vue'
import { loggedIn } from '@/hook'


const userStore = useUserStore()
const { isAuthorized, isValid, isLoggedIn } = storeToRefs(userStore)

const router = useRouter()
const isSsoLogin = computed(() => router.currentRoute.name === 'sso_login')

watch(
  isLoggedIn,
  async isLoggedIn => {
    if (!isLoggedIn) {
      return
    }
    await useConfigsStore().fill()
    await loggedIn()
  },
  { immediate: true }
)
</script>

<template>
  <SsoLogin v-if="isSsoLogin" />
  <template v-else>
    <template v-if="isAuthorized">
      <BlockScreen v-if="!isLoggedIn" />
      <template v-else>
        <SignedLayout v-if="isValid">
          <RouterView />
        </SignedLayout>
        <Fillinfo v-else />
      </template>
    </template>
    <Login v-else />
  </template>

  <Teleport
    to="body"
    v-if="isAuthorized"
  >
    <Modalstack />
  </Teleport>
  <Teleport to="body">
    <MessageStack />
  </Teleport>
</template>
